export const HIDE_ICON_FOR_SHARED_NAVIGATION_BAR = 'HIDE_ICON_FOR_SHARED_NAVIGATION_BAR';
export const DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR = 'DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR';
export const SET_NAVIGATION_ACTIVE = 'SET_NAVIGATION_ACTIVE';
export const HIDE_NAVIGATION = 'HIDE_NAVIGATION';
export const DISPLAY_NAVIGATION = 'DISPLAY_NAVIGATION';



// WEBPACK FOOTER //
// ./src/features/shared/navigationBar/constants.js